import { render } from "./ListLoader.vue?vue&type=template&id=1de24c34"
import script from "./ListLoader.vue?vue&type=script&lang=js"
export * from "./ListLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__